import { Container, Grid, useTheme } from "@mui/material";
import InvestmentCart from "./Component/InvestmentCart";
import InvestmentTable from "./Component/InvestmentTable";
import CreateInvestmentFund from "./Component/CreateInvestmentFund";
import WalletTabs from "./Component/WalletTabs";
import useIsMobileView from "hooks/useIsMobileView";
import HeaderWallet from "./Component/HeaderWallet";
import { History } from "assets/Icon";
import { ROUTE_PATHS } from "routes/paths";
import { useState } from "react";

function InvestmentFund() {
  const theme = useTheme();

  const [createInvestmentKey, setCreateInvestmentKey] = useState(1)

  const itemHeader = [
    {
      link: ROUTE_PATHS.history.request,
      icon: <History color={theme.palette.secondary.main} />,
    },
  ];

  const isMobileView = useIsMobileView();

  return (
    <Container maxWidth="100%">
      <Grid container spacing={1}>
        {isMobileView && <WalletTabs />}

        {isMobileView && <HeaderWallet itemHeader={itemHeader} my={0} />}

        <Grid item xs={12} md={6} lg={7}>
          <InvestmentCart />

          <InvestmentTable setCreateInvestmentKey={setCreateInvestmentKey} />
        </Grid>

        <Grid item xs={12} md={6} key={createInvestmentKey} lg={5}>
          <CreateInvestmentFund />
        </Grid>
      </Grid>
    </Container>
  );
}

export default InvestmentFund;
